import { render, staticRenderFns } from "./PrChartPressure.vue?vue&type=template&id=50216018&scoped=true&"
import script from "./PrChartPressure.vue?vue&type=script&lang=js&"
export * from "./PrChartPressure.vue?vue&type=script&lang=js&"
import style0 from "./PrChartPressure.vue?vue&type=style&index=0&id=50216018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50216018",
  null
  
)

export default component.exports